$(() => {
  // $('.personal_address_1')

  const $personal_address_1 = $('input[name="personal_address_1"]')
  const $address_input = $('input[name="personal_postal_code"], input[name="prefectures"], input[name="municipality"], input[name="building_name"]');

  const $input_prefectures = $('input[name="prefectures"]')
  const $input_municipality = $('input[name="municipality"]')
  const $input_building_name = $('input[name="building_name"]')

  $address_input.on('change input', function(e) {
    const prefectures = $input_prefectures.val()
    const municipality = $input_municipality.val()
    const building_name = $input_building_name.val()

    $personal_address_1.val(`${prefectures} ${municipality} ${building_name}`)
  })

  const form_reservation = document.querySelector('#form-reservation')

  if(form_reservation) {
    form_reservation.addEventListener('submit', function(e) {
      $('input[name="aaa3"]').val($('[name="schedule-select-1-day"]').val() + ' ' + + $('[name="schedule-select-1-time"]').val())
      $('input[name="aaa20"]').val($('[name="schedule-select-2-day"]').val() + ' ' + + $('[name="schedule-select-2-time"]').val())
    })
  }

  $('.card-check-model-house .card-check-model-house__body').on({
    'mouseenter': function() {
      if(window.matchMedia('(min-width: 768px').matches) {
        const $this = $(this)
        $this.find('.card-check-model-house__content').stop().fadeIn()
      }
    },
    'mouseleave': function() {
      if(window.matchMedia('(min-width: 768px').matches) {
        const $this = $(this)
        $this.find('.card-check-model-house__content').stop().fadeOut()
      }
    },
  })

  $('.card-check-model-house .card-check-model-house__btn').on('click', function() {
    const $this = $(this)

    if($this.hasClass('active')) {
      $this.removeClass('active')
      $this.find('span').text('情報を見る')
      $this.prev('.card-check-model-house__content').stop().slideUp()
    }else {
      $this.addClass('active')
      $this.find('span').text('閉じる')
      $this.prev('.card-check-model-house__content').stop().slideDown()
    }
  })
})
